import {
  Box,
  Button,
  Dialog,
  DialogProps,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Theme,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback, useState } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import assest from "../../json/assest";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  setManagerId,
  setPurchased,
  setUserId,
  setMonth,
  setYear,
  setSubmitPlace,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
  setPublished,
} from "../../redux-toolkit/slices/cleared.published.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  sampleDisplayList,
  sampleMonthsValueArray,
  sampleYearList,
  truncateString,
} from "../../lib/functions/utils.lib";
// import assest from "@/json/assest";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

// const names = [
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
// ];

// function getStyles(name, personName, theme) {
//   return {
//     fontWeight:
//       personName.indexOf(name) === -1
//         ? theme.typography.fontWeightRegular
//         : theme.typography.fontWeightMedium,
//   };
// }
// export type FilterModalProps = DialogProps & {
//     hideBottom?: boolean;
//     modalFields:
//         | {
//               has_note: string;
//               unreachable_submitter: string;
//               people_appearing: string;
//               person_who_filmed: string;
//               submit_other_website: string;
//               aggrement_with_another_company: string;
//           }
//         | any;
//     handleFilterParamChange: (event: ChangeEvent<HTMLInputElement>) => void;
//     resetFilterparams: () => void;
//     handleFilterSelect: () => void;
// };

import countries from "countries-list";
import { usePost } from "../../hooks/api/useFetch";

const partnerApproveFilterModal = (props) => {
  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );
  // console.warn('countryNames', countryNames);
  const {
    manager_id,
    hasMessage,
    purchased,
    published,
    user_id,
    month,
    year,
    submit_place,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
  } = useAppSelector((s) => s.publishedCleareddSlice);

  const { acquisitors, managers } = useAppSelector((s) => s.appStateSlice);
  console.warn(managers);

  // console.warn("acquisitors", acquisitors);
  // console.warn('month', month)

  const { hideBottom, onClose, modalFields, ...rest } = props;
  const dispatch = useAppDispatch();
  // const theme = useTheme();
  // const [personName, setPersonName] = React.useState([]);
  //console.warn(hideBottom,"hideBottom");
  //   console.warn('props.filterRefetch', props)
  //   console.warn('filterRowProps modal', filterRowProps);

  // const handleChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setPersonName(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };
  // console.warn('props', props)

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  //   console.warn(personName);
  const [mockMonth, setMockMonth] = useState({
    month: props?.modalMonthFilter,
  });
  const [mockYear, setMockYear] = useState(props?.modalYearFilter);
  const [mockLocation, setMockLocation] = useState(props?.modalLocationFilter);
  const [mockApprovedBy, setMockApprovedBy] = useState(null);
  const [mockUser, setMockUser] = useState();
  const [mockManager, setMockManager] = useState();

  // console.warn("mockManager", mockManager);

  // console.warn('props?.handleClearFilterModal', props)
  const [filterParams, setFilterParams] = useState({
    unreachable_submitter: "",
    people_appearing: "",
    person_who_filmed: "",
    submit_other_website: "",
    aggrement_with_another_company: "",
  });

  const resetFilter = () => {
    setFilterParams({
      unreachable_submitter: "",
      people_appearing: "",
      person_who_filmed: "",
      submit_other_website: "",
      aggrement_with_another_company: "",
    });
    setMockMonth(props?.modalMonthFilter);
    setMockYear(props?.modalYearFilter);
    setMockLocation(props?.modalLocationFilter);
    setMockApprovedBy("");
    props?.resetFilterparams();
  };

  const handleResetSingleField = (name) => {
    setFilterParams((prev) => {
      return { ...prev, [name]: "" };
    });
  };

  const handleFilterParamChange = (event) => {
    const { name, value } = event.target;
    setFilterParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const { data: approvedByList, isSuccess: approvedByListIsSuccess } = usePost(
    ["approved-by-users"],
    "admin/users-by-role",
    {
      role: [1, 6, 7],
    }
  );

  return (
    <Dialog className="filterModal" {...rest} onClose={handleClose}>
      <Box className="filterModalWrapper">
        <Box className="filterModalHeader">
          <h4>Filter</h4>
          <Button onClick={resetFilter}>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className="filterBodyBox">
            <Box className="partnerModal">
              <Box className="filterBoxItem filterApprove">
                <label>
                  Approved By{" "}
                  <img
                    onClick={() => setMockApprovedBy("")}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={mockApprovedBy}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!mockApprovedBy) {
                        return <span>None</span>;
                      } else {
                        return <span>{mockApprovedBy?.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      setMockApprovedBy(e.target.value);
                    }}
                  >
                    {approvedByListIsSuccess
                      ? approvedByList?.data?.length
                        ? approvedByList?.data.map((user, index) => (
                            <MenuItem key={index} value={user}>
                              {`${user?.name} ${user?.last_name}`}
                            </MenuItem>
                          ))
                        : ""
                      : ""}
                  </Select>
                </Box>
              </Box>

              <Box className="filterBoxItem filterFilmIn">
                <label>
                  Filmed in{" "}
                  <img
                    onClick={() => {
                      setMockMonth("");
                      setMockYear("");
                    }}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect filterSelectSmall">
                  <Select
                    labelId="month-label"
                    id="month-select"
                    displayEmpty
                    value={month}
                    renderValue={() => {
                      if (!mockMonth) {
                        return <span>Month</span>;
                      } else {
                        return <span>{mockMonth.month}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setMonth(e.target.value.value));
                      setMockMonth(e.target.value);
                    }}
                  >
                    {sampleMonthsValueArray.map((m, i) => (
                      <MenuItem key={i} value={m}>
                        {m.month}
                      </MenuItem>
                    ))}
                  </Select>
                  <Select
                    labelId="year-label"
                    id="year-select"
                    displayEmpty
                    value={mockYear}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span>Year</span>;
                      } else {
                        return <span>{selected}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      setMockYear(e.target.value);
                    }}
                  >
                    {sampleYearList.map((y, i) => (
                      <MenuItem key={i} value={y}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box className="filterBoxItem filterFilmLocation">
                <label>
                  Filming Location{" "}
                  <img
                    onClick={() => setMockLocation("")}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="location-label"
                    id="location-select"
                    displayEmpty
                    value={mockLocation}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <span>Location</span>;
                      } else {
                        return <span>{selected}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setSubmitPlace(e.target.value));
                      setMockLocation(e.target.value);
                      console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {countryNames.map((p, i) => (
                      <MenuItem key={i} value={p}>
                        {truncateString(p, 20)}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              <Box className="filterBoxItem filterDisplay">
                <label>
                  Display{" "}
                  <img
                    onClick={() => dispatch(setPublished(null))}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={published}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!published) {
                        return <span>All videos (default)</span>;
                      } else {
                        return <span>{published}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setPublished("yes"));
                    }}
                  >
                    {sampleDisplayList?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              {/* need to add into list */}

              <Box className="filterBoxItem filterUnreachable">
                <label>
                  Unreachable Submitter?{" "}
                  <img
                    src={assest.resetIconBlue}
                    onClick={() =>
                      handleResetSingleField("unreachable_submitter")
                    }
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={filterParams.unreachable_submitter}
                      name="unreachable_submitter"
                      /* onChange={(e) =>
                                                dispatch(
                                                    setUnreachableSubmitter(
                                                        e.target.value
                                                    )
                                                )
                                            } */
                      onChange={handleFilterParamChange}
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>

            {hideBottom === true ? (
              <Box className="filterBodyBox filterBodyBox2">
                <Box className="filterBoxItem">
                  <label>
                    Are There People Appearing In The Video?{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                      onClick={() => handleResetSingleField("people_appearing")}
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={filterParams.people_appearing}
                        name="people_appearing"
                        /* onChange={(e) =>
                                                    dispatch(
                                                        setPeopleAppearing(
                                                            e.target.value
                                                        )
                                                    )
                                                } */
                        onChange={handleFilterParamChange}
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    The Person Who Filmed This Video Is:{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() =>
                        handleResetSingleField("person_who_filmed")
                      }
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        // value={filterParams.person_who_filmed}
                        value={filterParams.person_who_filmed}
                        name="person_who_filmed"
                        // onChange={props?.handleFilterParamChange}
                        /* onChange={(e) =>
                                                    dispatch(
                                                        setPersonWhoFilmed(
                                                            e.target.value
                                                        )
                                                    )
                                                } */
                        onChange={handleFilterParamChange}
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="Me"
                            control={<Radio />}
                            label="Me"
                          />
                          <FormControlLabel
                            value="A Family Member"
                            control={<Radio />}
                            label="A Family Member"
                          />
                          <FormControlLabel
                            value="A Friend"
                            control={<Radio />}
                            label="A Friend"
                          />
                          <FormControlLabel
                            value="Someone I Know"
                            control={<Radio />}
                            label="Someone I Know"
                          />
                          <FormControlLabel
                            value="A Dashcam"
                            control={<Radio />}
                            label="A Dashcam"
                          />
                          <FormControlLabel
                            value="A Security Camera"
                            control={<Radio />}
                            label="A Security Camera"
                          />
                          <FormControlLabel
                            value="Other: the kid of my friend"
                            control={<Radio />}
                            label="Other: the kid of my friend"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    Did You Send/Submit/Upload This Video To A Website And/Or
                    Social Media Account?{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() =>
                        handleResetSingleField("submit_other_website")
                      }
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={filterParams.submit_other_website}
                        // value={filterParams.submit_other_website}
                        name="submit_other_website"
                        // onChange={props?.handleFilterParamChange}
                        /* onChange={(e) =>
                                                    dispatch(
                                                        setSubmitOtherWebsite(
                                                            e.target.value
                                                        )
                                                    )
                                                } */
                        onChange={handleFilterParamChange}
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="No, I Did Not"
                            control={<Radio />}
                            label="No, I Did Not"
                          />
                          <FormControlLabel
                            value="Yes, Another Company's Website"
                            control={<Radio />}
                            label="Yes, Another Company's Website"
                          />
                          <FormControlLabel
                            value="Yes, A Facebook Page"
                            control={<Radio />}
                            label="Yes, A Facebook Page"
                          />
                          <FormControlLabel
                            value="Yes, A Twitter Account"
                            control={<Radio />}
                            label="Yes, A Twitter Account"
                          />
                          <FormControlLabel
                            value="Yes, An Instagram Account"
                            control={<Radio />}
                            label="Yes, An Instagram Account"
                          />
                          <FormControlLabel
                            value="Yes, A YouTube Channel"
                            control={<Radio />}
                            label="Yes, A YouTube Channel"
                          />
                          <FormControlLabel
                            value="Yes, A Snaphat Account"
                            control={<Radio />}
                            label="Yes, A Snaphat Account"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    Did You Sign A Licensing Agreement For This Video With
                    Another Company/Page?{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() =>
                        handleResetSingleField("aggrement_with_another_company")
                      }
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={filterParams.aggrement_with_another_company}
                        // value={
                        //   props?.modalFields?.aggrement_with_another_company
                        // }
                        name="aggrement_with_another_company"
                        // onChange={props?.handleFilterParamChange}
                        /* onChange={(e) =>
                                                    dispatch(
                                                        setAgreementWithAnotherCompany(
                                                            e.target.value
                                                        )
                                                    )
                                                } */
                        onChange={handleFilterParamChange}
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="No, I Did Not"
                            control={<Radio />}
                            label="No, I Did Not"
                          />
                          <FormControlLabel
                            value="Yes, I Have Filled An Online Not"
                            control={<Radio />}
                            label="Yes, I Have Filled An Online Not"
                          />
                          <FormControlLabel
                            value="Yes, I Have Signed An Exclusive Agreement"
                            control={<Radio />}
                            label="Yes, I Have Signed An Exclusive Agreement"
                          />
                          <FormControlLabel
                            value="Yes, I Have Signed A Non-Exclusive Agreement"
                            control={<Radio />}
                            label="Yes, I Have Signed A Non-Exclusive Agreement"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
              </Box>
            ) : null}
          </Box>
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              className="activeButton"
              type="submit"
              // onClick={props?.filterRefetch}
              onClick={(e) => {
                props?.handleFilter({
                  ...filterParams,
                  selected: true,
                });
                props?.setFilterMonth(mockMonth?.month);
                props?.setFilterYear(mockYear);
                props?.setFilterLocation(mockLocation);
                handleClose(e);
              }}
            >
              Filter now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default partnerApproveFilterModal;
